import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi, formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = unauth, obj = user
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await adminApi.get("/admin/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    setError(null);
    try {
      const { data } = await adminApi.post("/admin/login", { email, password });
      if (data?.access_token) localStorage.setItem("fi_admin_token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const msg = formatApiError(e?.response?.data?.detail) || e.message;
      setError(msg);
      return { ok: false, error: msg };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminApi.post("/admin/logout");
    } catch {}
    localStorage.removeItem("fi_admin_token");
    setUser(false);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, error, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};
